import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faAngleUp,
  faArrowRightLong,
  faAt,
  faCheck,
  faChevronDown,
  faChevronRight,
  faCloudArrowUp,
  faCopy,
  faDownload,
  faEye,
  faEyeSlash,
  faLock,
  faMinus,
  faPen,
  faPhone,
  faPlane,
  faPlaneDeparture,
  faPlus,
  faShieldHeart,
  faSort,
  faSortDown,
  faSortUp,
  faTrash,
  faTrashAlt,
  faUmbrellaBeach,
  faXmark
} from '@fortawesome/free-solid-svg-icons';
import {
  faBagShopping as fadBagShopping,
  faBed as fadBed,
  faCalendarDays as fadCalendarDays,
  faCampfire as fadCampfire,
  faCartShopping as fadCartShopping,
  faCircleCheck as fadCircleCheck,
  faCircleHeart as fadCircleHeart,
  faCircleInfo as fadCircleInfo,
  faClock as fadClock,
  faCreditCard as fadCreditCard,
  faDumbbell as fadDumbbell,
  faEnvelopeCircleCheck as fadEnvelopeCircleCheck,
  faExternalLink as fadExternalLink,
  faFerrisWheel as fadFerrisWheel,
  faFileMagnifyingGlass as fadFileMagnifyingGlass,
  faGift as fadGift,
  faHandshake as fadHandshake,
  faHourglassStart as fadHourglassStart,
  faIdBadge as fadIdBadge,
  faLaptop as fadLaptop,
  faLocationDot as fadLocationDot,
  faMailbox as fadMailbox,
  faNoteSticky as fadNoteSticky,
  faPlaneDeparture as fadPlaneDeparture,
  faPrint as fadPrint,
  faRightToBracket as fadRightToBracket,
  faSearch as fadSearch,
  faShare as fadShare,
  faStarExclamation as fadStarExclamation,
  faUmbrellaBeach as fadUmbrellaBeach,
  faUser as fadUser,
  faUserGroup as fadUserGroup,
  faUtensils as fadUtensils
} from '@fortawesome/pro-duotone-svg-icons';

library.add(
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faAngleUp,
  faArrowRightLong,
  faAt,
  faCheck,
  faChevronDown,
  faChevronRight,
  faCloudArrowUp,
  faCopy,
  faDownload,
  faEye,
  faEyeSlash,
  faLock,
  faMinus,
  faPen,
  faPhone,
  faPlane,
  faPlaneDeparture,
  faPlus,
  faSort,
  faSortDown,
  faSortUp,
  faTrashAlt,
  faXmark,
  faUmbrellaBeach,
  faPlane,
  faPhone,
  faShieldHeart,
  faCopy,
  faTrash,
  // Duotone Icons
  fadBagShopping,
  fadBed,
  fadCalendarDays,
  fadCampfire,
  fadCartShopping,
  fadCircleCheck,
  fadCircleHeart,
  fadCircleInfo,
  fadClock,
  fadCreditCard,
  fadDumbbell,
  fadEnvelopeCircleCheck,
  fadExternalLink,
  fadFerrisWheel,
  fadGift,
  fadHandshake,
  fadHourglassStart,
  fadIdBadge,
  fadLaptop,
  fadLocationDot,
  fadFileMagnifyingGlass,
  fadMailbox,
  fadNoteSticky,
  fadPlaneDeparture,
  fadPrint,
  fadRightToBracket,
  fadSearch,
  fadShare,
  fadStarExclamation,
  fadUmbrellaBeach,
  fadUser,
  fadUserGroup,
  fadUtensils
);

export const faIconsList = library.definitions;
